import {
  Datagrid,
  List,
  Create,
  Edit,
  SimpleForm,
  TextField,
  TextInput,
  Show,
  SimpleShowLayout,
  usePermissions,
} from 'react-admin';
import { ArchivalToolbar } from '../components/ArchivalToolbar';
import { ArchivedSelect } from '../components/selects';
import { hasRole, type Permissions } from '../types';

const AssignmentList = () => {
  const { permissions } = usePermissions<Permissions>();
  return (
    <List
      exporter={false}
      filters={[<ArchivedSelect key="archived" />]}
      sort={{ field: 'name', order: 'ASC' }}
      perPage={25}
    >
      <Datagrid
        rowClick={hasRole(permissions, 'tenant_admin') ? 'edit' : 'show'}
      >
        <TextField label="Assignment Name" source="name" />
      </Datagrid>
    </List>
  );
};

const AssignmentShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="name" />
    </SimpleShowLayout>
  </Show>
);

const AssignmentCreate = () => (
  <Create>
    <SimpleForm toolbar={<ArchivalToolbar />}>
      <TextInput fullWidth source="name" />
    </SimpleForm>
  </Create>
);

const AssignmentEdit = () => (
  <Edit mutationMode="pessimistic">
    <SimpleForm toolbar={<ArchivalToolbar />}>
      <TextInput fullWidth source="name" />
    </SimpleForm>
  </Edit>
);

export const assignments = {
  list: AssignmentList,
  show: AssignmentShow,
  create: AssignmentCreate,
  edit: AssignmentEdit,
};
